module.exports = __webpack_public_path__ + "static/img/gpt73.d3915e5d.png";